module.exports = __webpack_public_path__ + "9779d9a1/img/search-filter-icon.c4751a52.svg";